import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search, select_id } from "../../../../Controllers/Global";
import moment from "moment";
import { get_project_task } from "../../../../Controllers/Projects/Tasks";
import Error from "../../../../Componets/Error";

const Projecttimesheetemployeestable = React.forwardRef((props, focus) => {
  const {
    project,
    task,
    setTask,
    taskOptions,
    setTaskOptions,
    employeeDetails,
    setEmployeeDetails,
    employeeTotals,
    setEmployeeTotals,
  } = props;

  const handleTaskSearch = async (e) => {
    const select = {
      api: "get-project-tasks",
      search: e,
      status: 1,
      project: project,
    };

    const search = await select_search(select);
    if (search?.status) {
      let options = [];
      search?.data?.data?.map((v, i) => {
        options?.push({ value: v?._id, label: v?.name });
      });

      setTaskOptions(options);
    }
  };

  const handleTask = async (e) => {
    if (e) {
      const params = {
        id: e,
      };

      const task = await get_project_task(params);

      if (task?.status) {
        setTask(task?.data?._id);

        let employee_details = [];
        let total = 0;

        task?.data?.employee_details?.map((value, i) => {
          employee_details?.push({
            task: value?._id,
            description: value?.description?._id,
            name: value?.description?.name,
            role: value?.description?.role?.name,
            hours: value?.hours ? value?.hours : 0,
            charges: value?.charges ? value?.charges : 0,
            worked: value?.hours ? value?.hours : 0,
            total:
              parseFloat(value?.hours || 0) * parseFloat(value?.charges || 0),
          });

          total =
            total +
            parseFloat(value?.hours || 0) * parseFloat(value?.charges || 0);
        });

        employeeTotals.total = total;
        setEmployeeDetails(employee_details);
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...employeeDetails];

      let data_charges = data[index]?.charges ? data[index]?.charges : 0;
      let data_worked = data[index]?.worked ? data[index]?.worked : 0;

      let worked = name === "worked" ? value : data_worked;

      let total = parseFloat(data_charges) * parseFloat(worked ? worked : 0);
      data[index][name] = value;
      data[index].total = total ? total?.toFixed(3) : 0;

      let grandtotal = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0
      );

      employeeTotals.total = grandtotal;

      setEmployeeDetails(data);
      setEmployeeTotals({ ...employeeTotals });
    }
  };

  return (
    <div>
      <div>
        <div>
          <Select
            name="task"
            placeholder="Project task"
            className="text-regular w-full"
            size="large"
            allowClear={false}
            showSearch={true}
            filterOption={false}
            options={taskOptions}
            value={task}
            onFocus={() => handleTaskSearch("")}
            onSearch={(e) => handleTaskSearch(e)}
            onChange={(e) => handleTask(e)}
            autoComplete="off"
          />
        </div>
        {employeeDetails?.length > 0 && (
          <div className="pt-4">
            <table className="w-full">
              <thead>
                <tr>
                  <td className="border p-4 text-black">S.No</td>
                  <td className="border p-4 text-black">Description</td>
                  <td className="border p-4 text-black">Role</td>
                  <td className="border p-4 text-black">Hours</td>
                  <td className="border p-4 text-black">Charges</td>
                  <td className="border p-4 text-black">Worked (Hours)</td>
                  <td className="border p-4 text-black">Total</td>
                </tr>
              </thead>
              <tbody>
                {employeeDetails?.map((value, index) => {
                  focus.current[`description${index}`] = createRef();
                  focus.current[`hours${index}`] = createRef();
                  focus.current[`charges${index}`] = createRef();

                  return (
                    <React.Fragment>
                      <tr>
                        <td className="border p-4 text-center">{index + 1}</td>
                        <td className="border p-4">
                          {value?.name}
                          <Error id={`description${index}`} />
                        </td>
                        <td className="border p-4 text-center">
                          {value?.role}
                        </td>
                        <td className="border p-4 text-center">
                          {value?.hours}
                          <Error id={`hours${index}`} />
                        </td>
                        <td className="border p-4 ">
                          {value?.charges}
                          <Error id={`charges${index}`} />
                        </td>
                        <td className="border p-4 ">
                          <Input
                            type="number"
                            className="w-full"
                            ref={focus.current[`worked${index}`]}
                            name="worked"
                            placeholder="Worked"
                            value={value?.worked}
                            onChange={(e) => handleTotal(e, index)}
                            autoComplete="off"
                          />
                          <Error id={`worked${index}`} />
                        </td>
                        <td className="border p-4 ">{value?.total}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td className="border p-4" colSpan={5}></td>
                  <td className="border p-4 text-black text-medium">Total</td>
                  <td className="border p-4 text-black text-medium" colSpan={2}>
                    {employeeTotals?.total > 0
                      ? employeeTotals?.total?.toFixed(3)
                      : "0.000"}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
});

export default Projecttimesheetemployeestable;
